import React from "react";
import {Header, WithHeader} from "@ekultur/header-microfrontend";
import {useAuthsDispatch, useAuthsState, USER_LOGGED_OUT,} from "../auths/authsContext";
import {login, logout} from "@ekultur/authentication";
import {useLocation} from "react-router";
import {MENU_OPENED, RENDERED, useAppDispatch} from "../app/AppContext";
import {themeOptions} from "../app/Theme";
import {useConfig} from "../config/useConfig";

const classes = {
    hamburger: "Header-hamburger",
};

export const AppHeader = () => {
    const {userIsAuthenticated} = useAuthsState();
    const dispatchAuths = useAuthsDispatch();
    const appDispatch = useAppDispatch();
    const location = useLocation();

    const {clearMuseum} = useConfig();

    const containerId = "header--container";

    const loginHandler = () => {
        const prevPath =
            location.state && location.state.previousPath
                ? location.state.previousPath
                : "/";
        login({
            locationPostLogin: prevPath,
            loginHost: window._env_.REACT_APP_LOGIN_HOST,
        });
    };

    const logoutHandler = () => {
        clearMuseum();
        logout({
            onLogout: () => dispatchAuths({type: USER_LOGGED_OUT}),
        });
    };
    return (
        <WithHeader>
            <Header
                appId={window._env_.REACT_APP_ID}
                containerId={containerId}
                loggedIn={userIsAuthenticated}
                mobileOpenHandler={() => appDispatch({type: MENU_OPENED})}
                logoutHandler={() => logoutHandler()}
                loginHandler={loginHandler}
                theme={themeOptions}
                preselectMuseumId={null}
                mobileOpen={false}
                onRender={() => appDispatch({type: RENDERED})}
                className={classes}
                version={window._env_.REACT_APP_VERSION}
                showNoAccessPlaceholder={true}
            />
        </WithHeader>
    );
};
